$(document).ready(function () {

    //enable checkout button after delivery app is loaded 
    const startTime = Date.now();
    const checkElement = setInterval(function () {
        if ($('.identixweb-order-delivery').length) {

            const secondsPassed = ((Date.now() - startTime) / 1000).toFixed(2);
            console.log(`Delivery App loaded after ${secondsPassed} seconds`);
            clearInterval(checkElement);
            setTimeout(() => {
                $(".template-cart #cart-footer-form #checkout").addClass('active')
            }, 2000);
        }
    }, 500);

    
    $(document).on("click",".orderDeliveryDatePostlCode", function () {
        setTimeout(function () {
            const borderColor = $(".order-delivery-date-postalcode-text").css("border-color");
            if(borderColor == "rgb(255, 0, 0)") $(".template-cart #cart-footer-form #checkout").removeClass('active')
            else $(".template-cart #cart-footer-form #checkout").addClass('active');
        }, 1000);
    });

    $(document).on("click",".shipping-identixweb-order-delivery-date", function () {
        setTimeout(function () {
            $(".template-cart #cart-footer-form #checkout").addClass('active');
        }, 1000);
    });    


    var maxVal = 6; // default fallback
    var inputs;

    // Get max value from body class
    function getMaxFromBody() {
        if ($("body").hasClass("sd-box-of-10")) {
            return 10;
        } else if ($("body").hasClass("sd-box-of-6")) {
            return 6;
        }
        return 6;
    }

    // Update input limits dynamically
    function updateInputs() {
        if (!$("body").hasClass("sd-mixed-box")) return;
        if (!inputs || !inputs.length) return;

        let total = 0;

        inputs.each(function () {
            total += parseInt($(this).val(), 10) || 0;
        });

        let remaining = maxVal - total;

        inputs.each(function () {
            let val = parseInt($(this).val(), 10) || 0;
            let dynamicMax = val + remaining;

            $(this).attr({
                max: dynamicMax,
                "data-max": dynamicMax
            });

            // Disable empty inputs when limit reached
            $(this).prop("disabled", remaining <= 0 && val === 0);
        });
    }

    // Apply min/max rules to all inputs
    function applyVariantMax() {
        if (!inputs || !inputs.length) return;

        maxVal = getMaxFromBody();

        inputs.attr({
            min: 0,
            "data-min": 0,
            max: maxVal,
            "data-max": maxVal,
            step: 1
        }).each(function () {
            if (!$(this).val()) $(this).val(0);
        });

        updateInputs();
    }

    // Initial load (delay for Globo app render)
    setTimeout(function () {
        inputs = $("#shopify-block-AVFliRVJtdFpCZXIvM__globo_product_options_app_block_ya3fMF input[type='number']");
        applyVariantMax();
    }, 1000);

    // Update on input changes
    $(document).on(
        "input change",
        "#shopify-block-AVFliRVJtdFpCZXIvM__globo_product_options_app_block_ya3fMF input[type='number']",
        function () {
            updateInputs();
        }
    );

});